// Desk cloud accounts (Better Auth). Sessions are bearer tokens, like the Mac and iPhone use,
// so nothing depends on cross-site cookies between app.deskapp.dev and api.deskapp.dev.
import { createAuthClient } from "better-auth/client";
import { emailOTPClient } from "better-auth/client/plugins";
import { CLOUD_URL } from "./session";

export const authClient = createAuthClient({
  baseURL: CLOUD_URL,
  plugins: [emailOTPClient()],
  fetchOptions: { credentials: "omit" },
});

export class AuthError extends Error {}

const fail = (error: { message?: string; status?: number } | null) =>
  new AuthError(error?.status === 429 ? "Too many attempts. Wait a minute and try again." : error?.message || "Something went wrong.");

export async function sendSignInCode(email: string): Promise<void> {
  const { error } = await authClient.emailOtp.sendVerificationOtp({ email, type: "sign-in" });
  if (error) throw fail(error);
}

/** Sign in with the emailed code; returns the bearer token for this browser. */
export async function signInWithCode(email: string, otp: string, deviceName: string): Promise<{ token: string; email: string }> {
  let token: string | null = null;
  const { data, error } = await authClient.signIn.emailOtp(
    { email, otp },
    {
      headers: { "x-desk-device-name": encodeURIComponent(deviceName), "x-desk-platform": "web" },
      onSuccess: (ctx) => {
        token = ctx.response.headers.get("set-auth-token");
      },
    },
  );
  if (error || !data) throw fail(error);
  const t = token ?? (data as { token?: string }).token;
  if (!t) throw new AuthError("Desk cloud didn't return a session.");
  return { token: t, email: data.user.email };
}

export async function signOutCloud(token: string): Promise<void> {
  await authClient.signOut({ fetchOptions: { headers: { authorization: `Bearer ${token}` } } });
}
